import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import classNames from 'classnames';
import { IlIcon } from '../IlIcon/index.js';
import { FW_PREFIX } from '../../shared/constants/generalConstants.js';

var IlBackToTopButton = /*#__PURE__*/function (_React$Component) {
  function IlBackToTopButton(props) {
    var _this;
    _classCallCheck(this, IlBackToTopButton);
    _this = _callSuper(this, IlBackToTopButton, [props]);
    _defineProperty(_this, "handleToScrollTop", function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    _defineProperty(_this, "handleScroll", function () {
      var _window = window,
        scrollY = _window.scrollY;
      _this.setState({
        isVisible: scrollY > (_this.props.scrollY ? _this.props.scrollY : 200)
      });
    });
    _this.state = {
      isVisible: props.open
    };
    return _this;
  }
  _inherits(IlBackToTopButton, _React$Component);
  return _createClass(IlBackToTopButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;
      var _this$props = this.props,
        className = _this$props.className,
        open = _this$props.open;
      return isVisible || open ? /*#__PURE__*/React__default.createElement("div", {
        className: classNames("".concat(FW_PREFIX, "__BackToTopContanier"), className)
      }, /*#__PURE__*/React__default.createElement("button", {
        className: classNames("".concat(FW_PREFIX, "__GoToTopButton")),
        onClick: this.handleToScrollTop
      }, /*#__PURE__*/React__default.createElement("div", null, "Back to Top"), /*#__PURE__*/React__default.createElement(IlIcon, {
        name: 'gs-arrows-top',
        className: classNames("".concat(FW_PREFIX, "__ArrowUpIcon"))
      }))) : null;
    }
  }]);
}(React__default.Component);

export { IlBackToTopButton };
